/* ============================================================
   ICE BLOOM
   A soft ice-blue glow that follows the pointer across every
   white surface on the site, with a small solid dot pinned to
   the cursor itself.

   WHY z-index:-1 RATHER THAN A BLEND MODE
   The obvious build is a full-screen layer with
   mix-blend-mode:multiply. It was rejected: multiply also
   tints the white TYPE sitting on the black sections, so every
   headline near the cursor turns blue, and it washes colour
   across product photography — unacceptable on a store where
   people judge a garment by its colour on screen.

   Instead the layer sits at z-index:-1, above the page's white
   canvas but beneath all content. Opaque dark sections and all
   imagery paint straight over it, so the bloom is visible on
   exactly the white ground and nowhere else.

   .ulth-face (the hero sheet) is the one exception: it is an
   absolutely positioned panel stacked above the page ground,
   so it gets its own copy of the bloom, positioned in the
   panel's own coordinates.
   ============================================================ */
(function () {
  'use strict';
  if (document.querySelector('.ul-glow')) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var layer = document.createElement('div');
  layer.className = 'ul-glow';
  layer.setAttribute('aria-hidden', 'true');

  var bloom = document.createElement('span'); bloom.className = 'ul-bloom';
  var dot   = document.createElement('span'); dot.className   = 'ul-dot';
  layer.appendChild(bloom);
  layer.appendChild(dot);

  var panel = null;     /* .ulth-face */
  var panelBloom = null;

  function mount() {
    document.body.appendChild(layer);

    panel = document.querySelector('.ulth-face');
    if (panel) {
      panelBloom = document.createElement('span');
      panelBloom.className = 'ul-bloom ul-bloom--panel';
      panelBloom.setAttribute('aria-hidden', 'true');
      panel.insertBefore(panelBloom, panel.firstChild);
    }
    requestAnimationFrame(function () { layer.classList.add('is-on'); });
  }

  /* ----------------------------------------------------------
     CLEARING A PATH FOR THE BLOOM

     The bloom sits at z-index:-1, so anything that paints its
     own opaque white on top of the page ground hides it — and
     the theme does that in a lot of places (.breadcrumb,
     .product-info, panels, placeholders...). Rather than chase
     that list by hand, neutralise them by rule:

       an element's own white background is redundant when the
       nearest painted surface BEHIND it is also white.

     That is exactly the case for every white-on-white panel,
     and never the case for a white chip sitting on a black
     section — which keeps its background and stays legible.
     ---------------------------------------------------------- */
  var RGB = /rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:[,/\s]+([\d.]+))?/;

  function parse(c){
    var m = RGB.exec(c || '');
    if (!m) return null;
    return { r:+m[1], g:+m[2], b:+m[3], a: m[4] === undefined ? 1 : +m[4] };
  }
  function opaque(c){ return c && c.a > 0.5; }
  function whitish(c){ return c && c.r >= 240 && c.g >= 240 && c.b >= 240; }

  /* nearest painted surface behind el; the canvas is white */
  function behind(el){
    var p = el.parentElement;
    while (p) {
      var c = parse(getComputedStyle(p).backgroundColor);
      if (opaque(c)) return c;
      p = p.parentElement;
    }
    return { r:255, g:255, b:255, a:1 };
  }

  /* An overlay's real backdrop is whatever it happens to float
     over, NOT its DOM parent — so the white-on-white test above
     is meaningless for one, and clearing it makes the panel
     see-through. (This is exactly how the cart drawer, a fixed
     white panel inside a white page, lost its background.)
     Anything under a fixed or sticky ancestor is left alone. */
  function overlay(el){
    var p = el;
    while (p && p !== document.body) {
      var pos = getComputedStyle(p).position;
      if (pos === 'fixed' || pos === 'sticky') return true;
      p = p.parentElement;
    }
    return false;
  }

  function clear(root){
    var all = (root || document.body).querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el === layer || layer.contains(el)) continue;
      if (el.hasAttribute('data-ul-cleared')) continue;

      var own = parse(getComputedStyle(el).backgroundColor);
      if (!opaque(own) || !whitish(own)) continue;
      if (overlay(el)) continue;               /* drawers, modals, sticky bars */
      if (!whitish(behind(el))) continue;      /* white on dark — leave it */

      el.style.backgroundColor = 'transparent';
      el.setAttribute('data-ul-cleared', '');
    }
  }

  function start(){
    mount();
    clear();
    document.addEventListener('shopify:section:load', function(){ clear(); });
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);

  /* target (tx,ty) is where the pointer is; (cx,cy) chases it,
     so the bloom drifts a beat behind the dot. */
  var tx = window.innerWidth * 0.5,
      ty = window.innerHeight * 0.40,
      cx = tx, cy = ty,
      dirty = true;

  window.addEventListener('resize', function () { dirty = true; }, { passive: true });

  function aim(x, y, pointer) {
    tx = x; ty = y; dirty = true;
    if (pointer) {
      if (!layer.classList.contains('has-pointer')) layer.classList.add('has-pointer');
      dot.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
    }
  }

  window.addEventListener('mousemove', function (e) {
    aim(e.clientX, e.clientY, true);
  }, { passive: true });

  function touch(e) {
    var t = e.touches && e.touches[0];
    if (t) aim(t.clientX, t.clientY, false);
  }
  window.addEventListener('touchstart', touch, { passive: true });
  window.addEventListener('touchmove',  touch, { passive: true });

  function frame() {
    if (dirty || Math.abs(tx - cx) > 0.15 || Math.abs(ty - cy) > 0.15) {
      if (reduce) { cx = tx; cy = ty; }
      else { cx += (tx - cx) * 0.085; cy += (ty - cy) * 0.085; }

      bloom.style.transform =
        'translate3d(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0)';

      /* the hero panel scrolls, so convert viewport coords into
         the panel's own box each frame it is on screen */
      if (panelBloom) {
        var r = panel.getBoundingClientRect();
        if (r.bottom > -400 && r.top < window.innerHeight + 400) {
          panelBloom.style.transform =
            'translate3d(' + (cx - r.left).toFixed(1) + 'px,' +
                             (cy - r.top).toFixed(1) + 'px,0)';
        }
      }
      dirty = false;
    }
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
})();
